<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
               {{year}} © IMODIGI 3.0
            </div>
            <!-- <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    Developed by Datadebug
                </div>
            </div> -->
        </div>
    </div>
</footer>